(() => {
  'use strict';

  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const init = (root) => {
    if (!root) return;

    const content = root.querySelector('[data-stories-interior-content]');
    const tocWrap = root.querySelector('[data-stories-toc-wrap]');
    const tocList = root.querySelector('[data-stories-toc-list]');
    const body = root.querySelector('[data-stories-interior-body]');
    const accordion = root.querySelector('[data-stories-toc-accordion]');

    if (!content || !tocWrap || !tocList || !body) return;

    const headings = Array.from(content.querySelectorAll('h2'));

    if (headings.length < 2) {
      body.setAttribute('data-toc-empty', '');
      tocWrap.setAttribute('aria-hidden', 'true');
      return;
    }

    const usedIds = new Set();
    const items = headings.map((h2) => {
      let id = h2.id || slugify(h2.textContent || '');
      if (!id) id = 'section';
      let candidate = id;
      let n = 2;
      while (usedIds.has(candidate)) {
        candidate = `${id}-${n}`;
        n += 1;
      }
      usedIds.add(candidate);
      h2.id = candidate;
      h2.classList.add('h3');
      return { id: candidate, text: h2.textContent.trim(), el: h2 };
    });

    tocList.innerHTML = '';
    items.forEach(({ id, text }, index) => {
      const li = document.createElement('li');
      li.className = 'stories-interior-toc__item';
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.className = 'stories-interior-toc__link paragraph-lg';
      a.dataset.tocLink = id;
      a.innerHTML = `
        <span class="stories-interior-toc__num">${index + 1}</span>
        <span class="stories-interior-toc__label">${text}</span>
      `;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    tocWrap.removeAttribute('aria-hidden');
    tocWrap.classList.add('is-ready');

    const desktopMq = window.matchMedia('(min-width: 750px)');
    const syncAccordion = () => {
      if (!accordion) return;
      if (desktopMq.matches) {
        accordion.open = true;
      } else {
        accordion.open = false;
      }
    };
    syncAccordion();
    desktopMq.addEventListener('change', syncAccordion);

    const linkById = new Map();
    items.forEach(({ id }) => {
      linkById.set(id, tocList.querySelector(`[data-toc-link="${id}"]`));
    });

    const setActive = (id) => {
      linkById.forEach((link, linkId) => {
        if (linkId === id) {
          link.classList.add('is-active');
          link.setAttribute('aria-current', 'location');
        } else {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting);
        if (visible.length > 0) {
          visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          setActive(visible[0].target.id);
        }
      },
      { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
    );
    items.forEach(({ el }) => observer.observe(el));

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    tocList.addEventListener('click', (event) => {
      const link = event.target.closest('[data-toc-link]');
      if (!link) return;
      event.preventDefault();
      const id = link.dataset.tocLink;
      const target = document.getElementById(id);
      if (!target) return;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
      history.replaceState(null, '', `#${id}`);
      if (accordion && accordion.open && window.matchMedia('(max-width: 749px)').matches) {
        accordion.open = false;
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('.stories-interior').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('shopify-section')) {
      const sectionRoot = event.target.querySelector('.stories-interior');
      if (sectionRoot) init(sectionRoot);
    }
  });
})();
